import { render, staticRenderFns } from "./Divergencias.vue?vue&type=template&id=7a1bd500&"
import script from "./Divergencias.vue?vue&type=script&lang=js&"
export * from "./Divergencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports